<template>
  <div>
    <titleBox name="旷真物业法律服务" imgUrl="../../assets/zhichanBg.jpg"></titleBox>
    <!-- 旷真物业法律服务 -->
    <div
      class="itemBox"
      style="
        background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/propertyLegalServices-01-BG.png);
      "
      id="fuwu"
    >
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/01.png"
          class="numberImg"
          alt=""
        />
        旷真物业法律服务
        <i class="redIcon"></i>
      </h2>
      <div v-for="wyflgItem in wyflgwList" class="mb-40">
        <h3 class="contenLittleTitle" v-if="wyflgItem.title">
          <div>{{wyflgItem.title}}</div>
          <div class="littleTitle-bottom">
            <div></div>
          </div>
        </h3>
        <p class="contenMsg" v-if="wyflgItem.describe1">{{wyflgItem.describe1}}</p>
        <p class="contenMsg mt-2" v-if="wyflgItem.describe2">{{wyflgItem.describe2}}</p>
        <p class="contenMsg mt-2" v-if="wyflgItem.describe3">{{wyflgItem.describe3}}</p>
      </div>
    </div>

    <div
      class="itemBox"
      id="liucheng"
    >
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/02.png"
          class="numberImg"
          alt=""
        />
        服务流程
        <i class="redIcon"></i>
      </h2>
      <div class="fwlc-content">
        <div
          v-for="(activity, index) in fwlcList"
          :key="index"
          class="fwlc-item"
        >
          <div class="timeline-left">
            <img
              src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/propertyLegalServices/propertyLegalServices-02-01.png"
              alt=""
              class="timeline-left-img"
            />
            <img
              :src="activity.icon"
              class="timeline-left-icon"
            />
          </div>
          <div class="timeline-center">
            <div class="timeline-dashed"></div>
            <div class="dot">•</div>
          </div>
          <div class="timeline-right">
            <div class="timeline-right-title">{{ activity.title }}</div>
            <div class="timeline-right-text" v-if="activity.content">
              {{ activity.content }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="itemBox"
      id="youshi"
      style="
        background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/propertyLegalServices-03-BG.png);
      "
    >
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/03.png"
          class="numberImg"
          alt=""
        />
        服务优势
        <i class="redIcon"></i>
      </h2>
      <div class="fwys-content">
        <div class="left">
          <div v-for="fwysItem in fwysLeftList" class="fwys-item" :style="`margin-bottom: ${fwysItem.marginBottom}rem`">
            <p class="content" v-if="fwysItem.title">{{fwysItem.title}}</p>
            <div class="fwysChild-item-content">{{fwysItem.content}}</div>
          </div>
        </div>
        <div class="center"></div>
        <div class="right">
          <div v-for="fwysItem in fwysRightList" class="fwys-item" :style="`margin-bottom: ${fwysItem.marginBottom}ren`">
            <p class="content" v-if="fwysItem.title">{{fwysItem.title}}</p>
            <div class="fwysChild-item-content">{{fwysItem.content}}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import titleBox from "../../components/titleBox/index";
export default {
  components: { titleBox },
  data() {
    return {
      wyflgwList: [
        {
          title: "物业行业现状",
          describe1: "在当前经济形势下，物业行业从增量市场走向存量市场，业主、租户、物业使用人对于物业服务的要求越来越多，但缴费意愿却越来越低。雪上加霜的是优质的项目非常有限，但每个物业公司都想争夺最优质的存量项目资源。",
          describe2: "与此同时，各部分部门监管力度持续增强，行政处罚及物业运营中的日常风险，比如业主纠纷、员工纠纷、物业费逾期等诸多法律风险，且上游房地产市场的不稳定因素，都给物业企业带来了更多不确定性。越来越多的物业企业意识到，布局高质量发展战略刻不容缓，而事前合规与法律风险防控已然成为当务之急。",
        },
        {
          title: "旷真物业法律顾问团队",
          describe1: "为助力广大物业企业实现合规健康发展，切实提升抗风险能力与治理水平，由TOP3上市物业企业资深法务团队组建的旷真律师事务所——物业企业法律服务部，深入聚焦物业企业全生命周期法律风险，精心研发出一系列物业行业法律解决方案。",
          describe2: "主理团队身经百战，直接参与数百件物业公司重大舆情和诉讼案件处理，同时拥有物业企业投融资、并购、IPO、税务等多元专业背景，熟悉开发商、业委会、业主、主管部门思维，掌握行业最新动态，持续追踪前沿问题，精准把握物业企业各类“疑难杂症”解决方案。",
        }
      ],
      fwlcList: [
        {
          title: '01 物业行业专属法务上岗，建立服务群',
          content: '对齐企业管理规模、业务特点、当下需求等基础信息，建立会员专属服务群，启动服务。',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/propertyLegalServices/propertyLegalServices-02-02.png",
        }, {
          title: '02 物业公司重点合规事项体检、筛查',
          content: '根据企业规模和发展阶段，结合物业企业全生命周期风险清单，通过材料审查、问卷调查等形式开展风险体检，排查潜在合规隐患。',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/propertyLegalServices/propertyLegalServices-02-03.png",
        }, {
          title: '03 物业企业合规风险解读，确定整改计划',
          content: '全面分析企业风险现状及潜在后果，形成法律风险体检报告，为企业解读现存风险，确定阶段性整改方案。',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/propertyLegalServices/propertyLegalServices-02-04.png",
        }, {
          title: '04 协助搭建、完善物业企业合规风控体系',
          content: '根据企业不同发展阶段及合规整改重点，协助物业企业搭建完善适配、落地的合规风控体系，数百份成熟的物业企业经营管理全流程配套制度、指引与合同模板拿来即用。',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/propertyLegalServices/propertyLegalServices-02-05.png",
        }, {
          title: '05 365天陪伴式服务，及时防控化解日常风险',
          content: '专属法务365天贴心陪伴，协助企业规章制度落地运行，及时处理日常咨询、文书审拟等法律事务，针对突发舆情和纠纷案件提供专业研判，有效防控化解风险。',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/propertyLegalServices/propertyLegalServices-02-06.png",
        }, {
          title: '06 阶段性专家走访与年度风险复盘',
          content: '团队定期走访、跟踪企业合规整改落地情况，阶段性评估企业法律风险现状，出具年度服务报告，复盘并汇报全年服务情况。',
          icon: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/propertyLegalServices/propertyLegalServices-02-07.png",
        },
      ],
      fwysLeftList: [
        {
          title: "01 铁三角服务模式",
          content: "由客户责任人（AR）、解决方案责任人（SR）和履行交付责任人（FR）组成项目管理团队，打破部门壁垒，提高响应速度，确保为客户提供更高的价值。",
          marginBottom: "0.2"
        }, {
          title: "03 一线实战经验丰富",
          content: "多年一线实战经验，将法律知识落地为有效的业务指导，帮助企业应对各种业态的挑战。",
          marginBottom: "0.2"
        }, {
          title: "05 百余件重大案件经验",
          content: "数百件物业重大舆情和诉讼案件的实战经验，精通风险防控和纠纷解决。",
          marginBottom: "0.2"
        }, {
          title: "07 服务专业高效",
          content: "团队化分工、标准化流程、可预期规划、阶段性汇报和可视化交付，确保服务的专业性和高效性。",
        }
      ],
      fwysRightList: [
        {
          title: "02 资深法务团队",
          content: "头部物企资深法务团队，深耕物业法律服务，助力物业企业稳健前行。",
          marginBottom: "0.2"
        }, {
          title: "04 个性化法律支持",
          content: "个性化的法律支持，提前防范风险，保障企业安全无忧。",
          marginBottom: "0.2"
        }, {
          title: "06 背景多元",
          content: "多元专业背景，把控行业动态，专业处理“疑难杂症”。",
        }
      ]
    };
  },
  methods: {
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.redColor {
  color: #ab0000;
}
.arrowIcon {
  position: relative;
  font-size: 0.1rem;
  top: -0.15rem;
  color: #fa6e23;
}
.itemBox {
  // width: 95%;
  margin: 0rem auto;
  padding: 0 0 0.5rem 0;
  background-color: #fff;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .titleBox {
    width: 95%;
    margin: auto;
    padding-top: 0.5rem;
    margin-bottom: 0.2rem;
    position: relative;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.5rem;

    .numberImg {
      position: relative;
      top: 0.05rem;
      width: 0.5rem;
      height: 0.5rem;
    }
  }
  .contenMsg {
    width: 87%;
    margin: 0 auto;
    box-sizing: border-box;
    padding-left: 0.2rem;
    line-height: 0.6rem;
    font-size: 0.35rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #666666;
  }
  .littleTitle {
    font-size: 0.4rem;
    text-align: center;
    color: #333333;
    img {
      width: 60%;
    }
    .littleTitle-bottom {
      display: flex;
      justify-content: center;
      margin-top: 0.2rem;
      div {
        width: 1.2rem;
        height: 0.1rem;
        background: #C8050F;
      }
    }
    // line-height: 1rem;
  }
  .mt-2 {
    margin-top: 0.2rem;
  }
  .contenLittleTitle {
    font-size: 0.4rem;
    text-align: center;
    color: #333333;
    img {
      width: 60%;
    }
    .littleTitle-bottom {
      display: flex;
      justify-content: center;
      margin-top: 0.2rem;
      div {
        width: 1.2rem;
        height: 0.1rem;
        background: #C8050F;
      }
    }
    // line-height: 1rem;
  }
  .fwlc-content {
    width: 95%;
    margin: 0.7rem auto;
    .fwlc-item {
      display: flex;
      flex-direction: row;
      .timeline-center {
        position: relative;
        width: 0.5rem;
        display: flex;
        .timeline-dashed {
          width: 0.2rem;
          border-left: 0.07rem dashed #ccc;
          height: 100%;
        }
        .dot {
          position: relative;
          display: flex;
          left: -0.32rem;
          color: #AB0000;
          font-size: 0.6rem;
        }
      }
      .timeline-left {
        width: 1.5rem;
        .timeline-left-img {
          width: 1rem;
        }
        .timeline-left-icon {
          width: 0.5rem;
          position: relative;
          top: -0.9rem;
          left: 0.24rem;
        }
      }
      .timeline-right {
        width: 100%;
        .timeline-right-title {
          color: #AB0000;
          font-size: 0.36rem;
          font-weight: bold;
          margin-bottom: 0.1rem;
        }
        .timeline-right-text {
          color: #4C4C4C;
          font-size: 0.3rem;
          padding-bottom: 0.5rem;
        }
      }
    }
  }
  .fwys-content {
    width: 95%;
    margin: 0rem auto;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    .left, .right {
      width: 46%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .fwys-item {
        .content {
          font-weight: bold;
          font-size: 0.32rem;
          background: #AB0000;
          color: #fff;
          padding: 0.1rem 0.04rem;
          border-radius: 0px 0.2rem 0px 0px;
          margin-bottom: 0rem;
          text-align: center;
          line-height: 0.6rem;
        }
        .fwysChild-item-content {
          padding: 0.3rem;
          font-size: 0.28rem;
          line-height: 0.45rem;
          color: #4C4C4C;
          background: #fff;
          border-left: 1px #AB0000 solid;
          border-bottom: 1px #AB0000 solid;
          border-right: 1px #AB0000 solid;
        }
      }
    }
    .center {
      margin-top: 0.4rem;
      border-left: 0.05rem dashed #CCCCCC;
    }
  }
}
.redIcon {
  position: relative;
  display: inline-block;
  top: -0.25rem;
  width: 10px;
  height: 7px;
  background-size: 100% 100%;
  background-image: url(http://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/redIcon.png);
}
</style>
